export const AllValue = 'All'
export const AllTranslationKey = 'all'
